import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import './index.css';

function ClerkWrapper({ children }) {
  const navigate = useNavigate();
  return (
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      routerPush={navigate}
      routerReplace={navigate}
      /* ---- component paths (match your dashboard) ---- */
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      afterSignOutUrl="/home"
      /* optional fallbacks if Clerk can't return user to a deep link */
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
    >
      {children}
    </ClerkProvider>
  );
}

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <BrowserRouter>
        <ClerkWrapper>
          <App />
        </ClerkWrapper>
      </BrowserRouter>
    </React.StrictMode>
  );
}
